export default __webpack_public_path__ + "static/media/ic_share.78234aa2.svg";